'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.controller('HeaderCtrl', function($rootScope, $location, $anchorScroll, userStore,
  $translate) {
  var self = this;
  
  this.mobileToggle = false;
  this.authenticated = false;
  this.showDropdown = false;

  $rootScope.$on('otppLogin.loginSuccess', function() {
    self.authenticated = true;
  });

  this.currentLanguage = function() {
    return $translate.use();
  };

  this.name = function() {
    return userStore.getFirstName() || null;
  };

  this.isActive = function(route) {
    return route === $location.path();
  };

  this.scrollTo = function(category) {
    // set the location.hash to the id of the element you wish to scroll to.
    $location.hash(category);
    $anchorScroll();
    angular.element('#' + category).focus();
  };

  this.isAuthenticated = function() {
    return this.authenticated;
  };

  this.toggleDropdown = function() {
    this.showDropdown = !this.showDropdown;
  };

  this.hideDropdown = function() {
    this.showDropdown = false;
  };
});
